import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';

interface FormFieldProps {
	label: string;
	/** RHF error message — either an i18n key (e.g. `validation.required`) or raw text; translated with a raw fallback. */
	error?: string;
	children: ReactNode;
}

/** Label + control + error wrapper shared by the System CRUD edit dialogs. */
export function FormField({ label, error, children }: FormFieldProps) {
	const { t } = useTranslation();
	return (
		<div className="flex flex-col gap-1.5">
			<Label className="text-xs font-medium text-foreground-subtle">{label}</Label>
			{children}
			{error && <span className="text-xs text-destructive">{t(error, { defaultValue: error })}</span>}
		</div>
	);
}
